import { Injectable } from '@angular/core';

import { DefaultPageSize } from 'src/app/config/defaults';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  public pagination(page = 1, size = DefaultPageSize): any {
    return {
      page,
      page_size: size,
    };
  }
}
